import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PUBLIC_BRAND_LOGO_SRC, PUBLIC_BRAND_LOGO_WHITE_SRC, PUBLIC_BRAND_WORDMARK } from 'src/app/core/branding/public-brand';
import { CoreService } from 'src/app/services/core.service';

@Component({
  selector: 'app-branding',
  imports: [RouterModule],
  templateUrl: './branding.component.html',
  styleUrl: './branding.component.scss',
})
export class BrandingComponent {
  /** Si es false, el logo es solo marca (sin navegar a inicio). */
  @Input() navigable = true;

  readonly brandWordmark = PUBLIC_BRAND_WORDMARK;
  readonly brandLogoSrc = PUBLIC_BRAND_LOGO_SRC;
  readonly brandLogoWhiteSrc = PUBLIC_BRAND_LOGO_WHITE_SRC;

  options = this.settings.getOptions();

  constructor(private settings: CoreService) {}
}
